"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfActionsNeededCountsDto = instanceOfActionsNeededCountsDto;
exports.ActionsNeededCountsDtoFromJSON = ActionsNeededCountsDtoFromJSON;
exports.ActionsNeededCountsDtoFromJSONTyped = ActionsNeededCountsDtoFromJSONTyped;
exports.ActionsNeededCountsDtoToJSON = ActionsNeededCountsDtoToJSON;
exports.ActionsNeededCountsDtoToJSONTyped = ActionsNeededCountsDtoToJSONTyped;
/**
 * Check if a given object implements the ActionsNeededCountsDto interface.
 */
function instanceOfActionsNeededCountsDto(value) {
    if (!('requestsCount' in value) || value['requestsCount'] === undefined)
        return false;
    if (!('shiftRequestsCount' in value) || value['shiftRequestsCount'] === undefined)
        return false;
    if (!('orientationRequestsCount' in value) || value['orientationRequestsCount'] === undefined)
        return false;
    if (!('totalRequestsCount' in value) || value['totalRequestsCount'] === undefined)
        return false;
    if (!('missingTimeSubmissionsCount' in value) || value['missingTimeSubmissionsCount'] === undefined)
        return false;
    if (!('shiftsMissingTimeSubmissionsCount' in value) || value['shiftsMissingTimeSubmissionsCount'] === undefined)
        return false;
    if (!('orientationsMissingTimeSubmissionsCount' in value) || value['orientationsMissingTimeSubmissionsCount'] === undefined)
        return false;
    return true;
}
function ActionsNeededCountsDtoFromJSON(json) {
    return ActionsNeededCountsDtoFromJSONTyped(json, false);
}
function ActionsNeededCountsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'requestsCount': json['requestsCount'],
        'shiftRequestsCount': json['shiftRequestsCount'],
        'orientationRequestsCount': json['orientationRequestsCount'],
        'totalRequestsCount': json['totalRequestsCount'],
        'missingTimeSubmissionsCount': json['missingTimeSubmissionsCount'],
        'shiftsMissingTimeSubmissionsCount': json['shiftsMissingTimeSubmissionsCount'],
        'orientationsMissingTimeSubmissionsCount': json['orientationsMissingTimeSubmissionsCount'],
    };
}
function ActionsNeededCountsDtoToJSON(json) {
    return ActionsNeededCountsDtoToJSONTyped(json, false);
}
function ActionsNeededCountsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'requestsCount': value['requestsCount'],
        'shiftRequestsCount': value['shiftRequestsCount'],
        'orientationRequestsCount': value['orientationRequestsCount'],
        'totalRequestsCount': value['totalRequestsCount'],
        'missingTimeSubmissionsCount': value['missingTimeSubmissionsCount'],
        'shiftsMissingTimeSubmissionsCount': value['shiftsMissingTimeSubmissionsCount'],
        'orientationsMissingTimeSubmissionsCount': value['orientationsMissingTimeSubmissionsCount'],
    };
}
//# sourceMappingURL=ActionsNeededCountsDto.js.map